import { LISBlock, LISCase, LISCaseList, LISSlide, LISSpecimen } from "pwapi";

import { ClinicList } from "custom-models/frontLoader";

import { ClinicsState, StainsState } from "shared/reducers/frontLoaderReducers";

const comparePriority = (
  priorityA: LISCase.priority | undefined,
  priorityB: LISCase.priority | undefined
) => {
  const rank = [
    LISCase.priority.STAT,
    LISCase.priority.RUSH,
    LISCase.priority.NORMAL,
    null,
    undefined,
  ];

  return rank.indexOf(priorityA) - rank.indexOf(priorityB);
};

const compareClinicTATPriority = (
  clinicA?: ClinicList,
  clinicB?: ClinicList
) => {
  return clinicA?.tat_priority === clinicB?.tat_priority
    ? 0
    : clinicA?.tat_priority
    ? -1
    : 1;
};

export const casesSort =
  (clinics: ClinicsState) => (a: LISCaseList, b: LISCaseList) => {
    const clinicA = clinics[a.patient?.clinic_id || 0];
    const clinicB = clinics[b.patient?.clinic_id || 0];

    const priority =
      comparePriority(a.priority, b.priority) ||
      compareClinicTATPriority(clinicA, clinicB);
    // TODO: could/should be smarter against comparing receieved_date, collected_date, etc
    if (!priority) return (a.id || 0) - (b.id || 0);
    return priority;
  };

export const specimenSort = (a: LISSpecimen, b: LISSpecimen) => {
  return a.name?.localeCompare(b.name || "") || 0;
};

export const blockSort = (a: LISBlock, b: LISBlock) => {
  // blockSort does not account for Specimen sorting.
  // Block records must first be sorted/grouped by Specimen with specimenSort().
  return (
    a.name?.localeCompare(b?.name || "", "en", {
      numeric: true,
      sensitivity: "base",
    }) || 0
  );
};

export const slideSort = (a: LISSlide, b: LISSlide) => {
  // slideSort does not account for Specimen or Block sorting.
  // Slide records must first be sorted/grouped by Specimen with specimenSort() and sorted/grouped by Block with blockSort().
  // This sorts by ID to sort Slides in the *order they were cut*. This is relevant in the lab.
  return (a.id || 0) - (b.id || 0);
};

export const slideSortByStainAndName =
  (stains: StainsState) => (a: LISSlide, b: LISSlide) => {
    if (a.stain_id !== b.stain_id) {
      const stainA = stains[a.stain_id || 0];
      const stainB = stains[b.stain_id || 0];
      return stainA.abbreviation.localeCompare(stainB.abbreviation, "en");
    }

    return (
      a.slide_number?.localeCompare(b?.slide_number || "", "en", {
        numeric: true,
        sensitivity: "base",
      }) || 0
    );
  };
